<template>
  <span v-if="iconClass">
    <font-awesome-icon :class="`follow-up ${classes}`" :icon="['fal', iconClass]" />
  </span>
</template>

<script type="text/babel">
const classes = ["dice-one", "dice-two", "dice-three", "dice-four", "dice-five", "dice-six"];

export default {
  props: {
    job: {
      default: null,
    },
    classes: {
      default: "",
    },
  },

  computed: {
    iconClass() {
      if (
        this.job &&
        this.job.current_follow_up &&
        this.job.current_follow_up > 0 &&
        this.job.current_follow_up <= 6
      ) {
        return classes[this.job.current_follow_up - 1];
      }

      return false;
    },
  },
};
</script>
